import { render } from "./DNDHome.vue?vue&type=template&id=bbaa27e0&scoped=true&ts=true"
import script from "./DNDHome.vue?vue&type=script&lang=ts"
export * from "./DNDHome.vue?vue&type=script&lang=ts"

import "./DNDHome.vue?vue&type=style&index=0&id=bbaa27e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbaa27e0"]])

export default __exports__